import clsx from 'clsx';
import React, { useMemo } from 'react';
import TabItem from './Item';
import styles from './styles.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";

const TabList = _ref => {
  let {
    children,
    className,
    variant: srcVariant = ''
  } = _ref;
  const variantClasses = useMemo(() => {
    const variants = Array.isArray(srcVariant) ? srcVariant : [srcVariant];
    return variants.filter(Boolean).map(variant => styles[`container--${variant}`]);
  }, [srcVariant]);
  return /*#__PURE__*/_jsx("ul", {
    className: clsx(styles.container, ...variantClasses, className || ''),
    children: children
  });
};

export default TabList;
export { TabItem };